import React from "react";

type Props = {
  value?: string;
  checked?: boolean;
  label: string;
  count?: number;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  hex?: string | null;
  image?: string | null;
  isAge?: boolean;
};

export const Checkbox: React.FC<Props> = ({ value, checked, label, count, onChange, hex, image, isAge }) => (
  <label className={`checkbox ${hex ? "color" : ""}`}>
    <input type="checkbox" value={value} checked={checked} onChange={onChange} />
    <span
      className={`check-bg ${hex ? "filled" : ""}`}
      style={{
        backgroundImage: image ? `url(${image})` : undefined,
        backgroundColor: hex ?? undefined,
        borderColor:
          hex && hex.toLowerCase() !== "white" && hex.toLowerCase() !== "#fff" && hex.toLowerCase() !== "#ffffff"
            ? hex
            : undefined,
      }}
    />
    <ui-icon name="icon-check-small" class="icon-checkmark" width="16" height="16"></ui-icon>
    <span aria-hidden="true" className="checkbox__label" data-label={label}>
      {isAge ? label
        .toLowerCase()
        .replace(/(?:^|\s)\S/g, function (match) {
          return match.toUpperCase();
        }) : label
        .toLowerCase()
        .replace(/-/g, " ")
        .replace(/(?:^|\s)\S/g, function (match) {
          return match.toUpperCase();
        })}
      {!isNaN(count) && <span data-label={`(${count})`}>({count})</span>}
    </span>
  </label>
);
